import { http } from 'src/utils/http.util'
import type { TLifenPatientSearchDiagnostic } from 'src/types/lifen'

export const LifenService = {
  searchPatient: (projectId: number, remoteId: string): Promise<TLifenPatientSearchDiagnostic> =>
    http
      .post(`/projects/${projectId}/backoffice/lifen-patient-search`, { remoteId })
      .then((res) => res.data),
}
